module.exports = __webpack_public_path__ + "static/img/works-05.6c191fa2.png";